// Schema version 2: rename legacy effect type aliases to their current names.
// "triangle" was the old name for what is now the "zigzag" effect. "saw" was
// zigzag with skew always fixed at 0 — the simple variant, in the same
// relationship as "bounce" is to "swell".
export default {
  schema_version: 2,
  migrate(config) {
    for (const patch of config.patches ?? []) {
      for (const effect of patch.effects ?? []) {
        if (effect.type === 'triangle') {
          effect.type = 'zigzag';
        } else if (effect.type === 'saw') {
          effect.type = 'zigzag';
          effect.skew = 0;
        }
      }
    }
  },
};
